import "./Factories.css"
import { IoIosCheckmarkCircle } from "react-icons/io";
import { FaRegEye, FaProjectDiagram, FaChartLine } from "react-icons/fa";
import { FaMedal, FaGlobe, FaCogs, FaHandshake } from "react-icons/fa";
import ResponsiveContainer from "../../../responsive/components/ResponsiveContainer/ResponsiveContainer";

const Factories = () => {
    const features = [
        {
            title: "Automated Compliance Tracking",
            desc: "Real-time monitoring of regulatory requirements across multiple jurisdictions",
        },
        {
            title: "Digital Documentation",
            desc: "Centralized repository for all certification documents and audit trails",
        },
        {
            title: "Expert Support",
            desc: "Access to regulatory experts and dedicated support throughout the process",
        },
    ];

    const qualityFeatures = [
        {
            title: "Real-time Quality Monitoring",
            desc: "Continuous oversight of production quality with instant alerts",
            icon: <FaRegEye />, // Eye icon
        },
        {
            title: "Traceability Solutions",
            desc: "End-to-end tracking from raw materials to finished products",
            icon: <FaProjectDiagram />, // Diagram/network icon
        },
        {
            title: "Predictive Analytics",
            desc: "AI-powered insights to prevent quality issues before they occur",
            icon: <FaChartLine />, // Chart/analytics icon
        },
    ];

    const businessFeatures = [
        {
            title: "Market Leadership",
            desc: "Position your brand as an industry leader through superior quality and compliance",
            icon: <FaMedal />, // Medal = leadership/award
        },
        {
            title: "Global Expansion",
            desc: "Enter new markets with confidence through streamlined regulatory compliance",
            icon: <FaGlobe />, // Globe = worldwide
        },
        {
            title: "Operational Excellence",
            desc: "Optimize production processes and reduce operational costs significantly",
            icon: <FaCogs />, // Gears = efficiency/operations
        },
        {
            title: "Brand Trust",
            desc: "Build consumer confidence through transparent quality assurance",
            icon: <FaHandshake />, // Handshake = trust/partnership
        },
    ];

    return (
        <ResponsiveContainer>
            <div className="factories-page ">
                <div className="factories-header">
                    <h1 className="factories-title">For Factories</h1>
                </div>

                <section className="factories-section streamline-certification">
                    <div className="content">
                        <h2>Streamline Certification</h2>
                        <p>Navigate complex regulatory requirements with confidence. Our comprehensive certification platform automates compliance workflows, reduces documentation overhead, and accelerates time-to-market for your products.</p>
                        <div className="features">
                            {features.map((feature, index) => (
                                <div key={index} className="feature">
                                    <h3>
                                        <IoIosCheckmarkCircle className="icon" />
                                        {feature.title}
                                    </h3>
                                    <p>{feature.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="image">
                    </div>
                </section>

                <section className="factories-section enhance-quality">
                    <h2>Enhance Product Integrity</h2>
                    <p>Build consumer trust through comprehensive quality assurance. Our integrated monitoring systems provide real-time visibility into your production processes, ensuring consistent quality and regulatory compliance.</p>
                    <div className="features-enhance-quality">
                        {qualityFeatures.map((feature, index) => (
                            <div key={index} className="feature-enhance-quality">
                                <div className="icon">
                                    {feature.icon}
                                </div>
                                <h3>
                                    {feature.title}
                                </h3>
                                <p>{feature.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="factories-section competitive-advantage ">
                    <div className="image">

                    </div>
                    <div className="content">
                        <h2>Gain a Competitive Advantage</h2>
                        <p>Stay ahead of the competition with data-driven insights and operational excellence. Our platform transforms your manufacturing capabilities, enabling faster decision-making and superior market positioning.</p>

                        <div className="features-competitive-advantage">
                            {businessFeatures.map((feature, index) => (
                                <div key={index} className="feature-competitive-advantage">
                                    <div className="icon">
                                        {feature.icon}
                                    </div>
                                    <h3>
                                        {feature.title}
                                    </h3>
                                </div>
                            ))}
                        </div>
                    </div>

                </section>
            </div>
        </ResponsiveContainer>
    )
}

export default Factories
